import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as Download } from '../../../assets/images/svg/download.svg';
import themeColors from '../../../assets/styles/themeColors';

const DownloadStyled = styled(Download)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorTextPrimary};
`;

const DownloadIcon = (props) => <DownloadStyled {...props} />;

DownloadIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

DownloadIcon.defaultProps = {
  w: '24px',
  h: '24px',
};

export default DownloadIcon;
